import html2canvas from 'html2canvas';

export async function captureScreenshot(): Promise<Blob | null> {
  try {
    const canvas = await html2canvas(document.body, {
      allowTaint: true,
      useCORS: true,
      logging: false,
      scale: 0.5, // Reduce size for faster upload
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    });
    
    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.8);
    });
  } catch (error) {
    console.error('Screenshot capture failed:', error);
    return null;
  }
}
